import { idX } from "@insightfulscience/shared-utils/fn";
import nextSignleton from "../utils/nextSignleton";
import createStorage from "./create-storage";
import Token from "./token";

export const PriceItem = createStorage("selectedItem");

export const BillingInfo = createStorage("billingInfo");

export const CancelSurvey = createStorage("cancelSurvey");

export const ref = nextSignleton(context => {
	let priceItemRef = PriceItem;
	let billingInfoRef = BillingInfo;
	let cancelSurveyRef = CancelSurvey;

	const setPriceItem = (priceItem = PriceItem) => {
		priceItemRef = priceItem;
	};

	const setBillingInfo = (billingInfo = BillingInfo) => {
		billingInfoRef = billingInfo;
	};

	const setCancelSurvey = (cancelSurvey = CancelSurvey) => {
		cancelSurveyRef = cancelSurvey;
	};

	return {
		get PriceItem() {
			return priceItemRef(context);
		},
		get BillingInfo() {
			return billingInfoRef(context);
		},
		get CancelSurvey() {
			return cancelSurveyRef(context);
		},
		setPriceItem,
		setBillingInfo,
		setCancelSurvey,
	};
});

export const RefreshToken = createStorage("rtoken", idX, idX);

export { Token };

export const clearAll = context => {
	PriceItem(context).clear();
	BillingInfo(context).clear();
	Token(context).set(null);
	RefreshToken(context).clear();
	CancelSurvey(context).clear();
};
